import React from 'react';
import { AiOutlineCodepen, AiOutlineFileText } from 'react-icons/ai';
import { FaSnowflake } from 'react-icons/fa';
import { FiCodesandbox } from 'react-icons/fi';
import { RiBracesLine } from 'react-icons/ri';
import { match } from 'ts-pattern';

import { Icon } from '@/components/icon/icon';
import { Tooltip } from '@/components/tooltip/tooltip';
import { Source } from '@/types/evals';

export const getResourceName = ( source: Source ): string => match( source )
  .with( { source_type: 'snowflake' }, ( { config: snowflakeConfig } ) => {
    return `${ snowflakeConfig.database_name }.${ snowflakeConfig.schema_name || '-' }`;
  } )
  .with( { source_type: 'json' }, ( { config: jsonConfig } ) => {
    return jsonConfig['dfd'] as string || '-';
  } )
  .with( { source_type: 'mas_model_invocation_log' }, ( { config: { filters } } ) => {
    return filters.agent_id || `${ filters.constellation_name }.${ filters.agent_name || '-' }`;
  } )
  .with( { source_type: 'mas_agent_action_log' }, ( { config: { filters } } ) => {
    return filters.agent_id || `${ filters.constellation_name }.${ filters.agent_name || '-' }`;
  } )
  .with( { source_type: 'mas_completion_log' }, ( { config: { filters } } ) => {
    return filters.agent_id || `${ filters.constellation_name }.${ filters.agent_name || '-' }`;
  } )
  .exhaustive( ( source ): string => {
    console.error( 'Unknown source provided at runtime:', source );
    return '-';
  } );

export const getResourceIcon = ( source: Source ): React.ReactElement => match( source )
  .with( { source_type: 'snowflake' }, () => (
    <Tooltip content="Snowflake" position="top">
      <Icon icon={ FaSnowflake } />
    </Tooltip>
  ) )
  .with( { source_type: 'json' }, () => (
    <Tooltip content="JSON" position="top">
      <Icon icon={ RiBracesLine } />
    </Tooltip>
  ) )
  .with( { source_type: 'mas_agent_action_log' }, () => (
    <Tooltip content="Agent Action Log" position="top">
      <Icon icon={ FiCodesandbox } />
    </Tooltip>
  ) )
  .with( { source_type: 'mas_model_invocation_log' } , () => (
    <Tooltip content="Model Invocation Log" position="top">
      <Icon icon={ AiOutlineCodepen } />
    </Tooltip>
  ) )
  .with( { source_type: 'mas_completion_log' } , () => (
    <Tooltip content="Request/Response Log" position="top">
      <Icon icon={ AiOutlineFileText } />
    </Tooltip>
  ) )
  .exhaustive( ( s ): React.ReactElement => {
    console.error( 'Unknown source provided at runtime:', s );
    return (
      <Tooltip content="Unknown" position="top">
        <Icon icon={ RiBracesLine } />
      </Tooltip>
    );
  } );
